import apiClient from "../api/apiClient";

export const fetchCustomerPriceList = async (customerId, dateFrom, dateTo) => {
  let url = `/price-details?customerNo=${customerId}`;
  if (dateFrom) url += `&dateFrom=${dateFrom}`;
  if (dateTo) url += `&dateTo=${dateTo}`;

  return apiClient(url, { method: "GET" });
};

export const fetchCustomerPriceListExcel = async (
  customerId,
  dateFrom,
  dateTo
) => {
  let url = `/price-excel?customerNo=${customerId}`;
  if (dateFrom) url += `&dateFrom=${dateFrom}`;
  if (dateTo) url += `&dateTo=${dateTo}`;

  return apiClient(url, { method: "GET" });
};
